import HighlightsItem, {
  HighlightItem,
} from "@/components/Highlights/HighlightsItem";

type AboutCertificateProps = {
  highlights: HighlightItem[];
  partnerName: string;
};

export default function AboutCertificate({
  highlights,
  partnerName,
}: AboutCertificateProps) {
  return (
    <>
      {highlights.map((highlight, index) => {
        return (
          <div
            className="flex justify-center border-2 rounded-xl bg-white px-4 py-6"
            key={index}
          >
            <HighlightsItem
              key={highlight.title}
              partnerName={partnerName}
              {...highlight}
            />
          </div>
        );
      })}
    </>
  );
}
